import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { MatButton } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { AccountService, ResetPasswordDto } from '../../../services/account.service';
import { SnackbarService } from '../../../services/snackbar.service';
import { environment } from '../../../../environments/environment';
import { SetNewPasswordRequest } from '../../../model/userModel';

@Component({
  selector: 'app-reset-password',
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatLabel,
    MatButton,
    MatCardModule,
    RouterLink,
  ],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss',
})
export class ResetPasswordComponent implements OnInit {
  private fb = inject(FormBuilder);
  accountService = inject(AccountService);
  private router = inject(Router);
  private snackbar = inject(SnackbarService);
  private route = inject(ActivatedRoute);
  token = '';
  userId = '';

  production = environment.production;
  height = 0;

  loginForm = this.fb.group({
    newPassword: [''],
    newPasswordConfirm: [''],
  });

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.token = params['token'];

      this.userId = params['userId'];
      console.log('Token:', this.token);
      console.log('UserId:', this.userId);
      if (!this.token || !this.userId) {
        this.router.navigate(['/login']);
      }
    });
  }

  onSubmit(): void {
    var resquest: ResetPasswordDto = {
      newPassword: this.loginForm.value.newPassword ?? '',
      newPasswordConfirm: this.loginForm.value.newPasswordConfirm ?? '',
      token: this.token,
    };
    this.accountService.resetPasswordWithToken(resquest, this.userId as unknown as number);
  }
}
